export default {
    articles: state => state.articles,
    booking: state => state.booking,
    metadata: state => state.metadata,
    packages: state => state.packages,
    reviews: state => state.reviews,
    specialist: state => state.specialist,
    userServices: state => state.userServices,
    isLoading: state => state.isLoading,
    isLoadingAvailabilityDates: state => state.isLoadingAvailabilityDates,

    transactions           : state => state.transactions,
    transactionsAppearance : state => state.transactionsAppearance,
    transactionsEnd        : state => state.transactionsEnd,
    transactionsLoading    : state => state.transactionsLoading,
}
